import React, { ReactElement } from 'react';
import { Box, Card, Checkbox, Divider } from '@mui/material';
import classNames from 'classnames';

import styles from './BaseLendingTile.module.scss';

export type BaseTileParams = {
  header?: ReactElement | null;
  body?: ReactElement | null;
  footer?: ReactElement | null;
  checked?: boolean;
  checkboxDisabled?: boolean;
  onCheckboxToggle?: () => void;
  onClick?: () => void;
  isSelected?: boolean;
  height?: React.CSSProperties['height'];
};

/**
 * Most basic building block of a tile. Handles:
 *   - Generic header/body/footer rendering
 *   - isSelected styling
 *   - Checkbox display and handling
 */
export function BaseTile({
  header,
  body,
  footer,
  checked,
  checkboxDisabled,
  onCheckboxToggle,
  onClick,
  isSelected,
  height,
}: BaseTileParams) {
  const displayCheckbox =
    checked !== undefined && onCheckboxToggle !== undefined;

  return (
    <Card
      sx={{ height }}
      className={classNames(styles.tile, {
        [styles.selected]: isSelected,
      })}
    >
      {displayCheckbox && (
        <>
          <Box
            className={styles.checkbox}
            onClick={() => {
              if (!checkboxDisabled) {
                onCheckboxToggle();
              }
            }}
            data-testid="tile-checkbox-section"
          >
            <Checkbox
              size="small"
              checked={checked}
              disabled={checkboxDisabled}
              data-test-id="select-vehicle"
              sx={{ padding: 0 }}
            />
          </Box>
          <Divider className={styles.divider} orientation="vertical" flexItem />
        </>
      )}

      <button
        type="button"
        className={classNames(styles.content, {
          [styles.hover]: !!onClick,
        })}
        onClick={onClick}
      >
        {header}
        <div className={styles.tileBody}>{body}</div>
        <div className={styles.footer}>{footer}</div>
      </button>
    </Card>
  );
}
